import Header from "../components/header";
import Hero from "../components/hero";
import Services from "../components/services";
import TechStack from "../components/tech-stack";
import Cases from "../components/cases";
import Team from "../components/team";
import FAQ from "../components/faq";
import Contact from "../components/contact";
import Footer from "../components/footer";

export default function Home() {
  return (
    <>
      <title>Sprintwise - Продуктовая разработка и цифровые решения</title>
      <meta name="description" content="Sprintwise - команда экспертов по продуктовой разработке. Создаем качественные цифровые продукты на современных технологиях." />
      <meta name="keywords" content="продуктовая разработка, цифровые продукты, веб-разработка, мобильные приложения, современные технологии" />
      <meta property="og:title" content="Sprintwise - Продуктовая разработка и цифровые решения" />
      <meta property="og:description" content="Создаем качественные цифровые продукты на базе современных технологий" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://sprintwise.ru" />
      <link rel="canonical" href="https://sprintwise.ru" />
      
      <div className="min-h-screen bg-light-bg overflow-x-hidden">
        {/* Data Flow Animation Background */}
        <div className="fixed inset-0 pointer-events-none z-0">
          <div className="data-particle animate-data-flow" style={{ top: '20%', animationDelay: '0s' }}></div>
          <div className="data-particle animate-data-flow" style={{ top: '40%', animationDelay: '2s' }}></div>
          <div className="data-particle animate-data-flow" style={{ top: '60%', animationDelay: '4s' }}></div>
          <div className="data-particle animate-data-flow" style={{ top: '80%', animationDelay: '6s' }}></div>
        </div>
        
        <Header />
        <Hero />
        <Services />
        <TechStack />
        <Cases />
        <Team />
        <FAQ />
        <Contact />
        <Footer />
      </div>
    </>
  );
}
